export const deleteRequestData = [
  {
    id: 'U461893',
    name: 'Janet',
    requisitionDate: '25 Mar 2024',
    deleteRequestDate: '27 Mar 2024',
    status: 'Confirm',
    key: 1,
    img: 'assets/img/students/student-01.jpg',
  },
];
